module.exports = __webpack_public_path__ + "img/blurry-silhouette-512x512.307cf1e6.png";